import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import ListenerChangeCard from "./listenerchangecard.component";
import ls from 'local-storage';
export default class ListenerChangeCardDetails extends Component {	
	
	componentDidMount(){
		document.title = "CONQER Music - Listener Registration";
		ls.set('registration_type', '');
		ls.set('registration_type', this.props.match.params.type);
	}
	
    render() { return (<ListenerChangeCard />)}
}